export default __webpack_public_path__ + "abef6b9d45d91ace8c9a477abf008f92.png";